/**
 * AlertSyncIndicator — connection health dot indicator.
 * Green = connected, Yellow = stale data, Red = disconnected/error.
 */

const AlertSyncIndicator = ({ isConnected, isDataStale, connectionError }) => {
    let dotClass = 'na-sync-dot--connected';
    let label = 'Connected';

    if (connectionError || !isConnected) {
        dotClass = 'na-sync-dot--disconnected';
        label = connectionError || 'Disconnected';
    } else if (isDataStale) {
        dotClass = 'na-sync-dot--stale';
        label = 'Data may be stale';
    }

    return (
        <div className="na-sync" title={label}>
            <span className={`na-sync-dot ${dotClass}`} />
            <span>{label}</span>
        </div>
    );
};

export default AlertSyncIndicator;
